import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { POStatus } from "../../models/FDropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { JVDate } from "../../shared/JVDate";
import { InputTextarea } from "primereact/inputtextarea";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";


interface Iprops {
    po: IPurchaseOrder
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

const schema = yup.object({
    pO_Status: yup.string().required("PO Status is Required."),
    project_End_Date: yup.date().required("End Date is required").typeError("End Date is required"),
    notSendEmail: yup.boolean().nullable(),
});

export const Edit = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [valuetextarea, setValuetextarea] = useState<string>('');
    const [errortextarea, setErrortextarea] = useState<boolean>(false)

    const { control, handleSubmit, formState: { errors }, watch, reset } = useForm<IPurchaseOrder | { project_End_Date?: Date, pO_Status?: string, notSendEmail?: boolean }>({
        resolver: yupResolver(schema),
        defaultValues: { pO_Status: "", notSendEmail: false },
        shouldFocusError: false
    });
    const [showTextArea, setShowTextArea] = useState(false);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    useEffect(() => {
        if (props.open) {
            if (props.po.project_End_Date) props.po.project_End_Date = new Date(props.po.project_End_Date);
            if (props.po.pO_Status === "Fizzled") {
                setShowTextArea(true);
            }
            reset({ pO_Status: props.po.pO_Status, project_End_Date: props.po.project_End_Date });
        }
    }, [props.open, props.po]);

    const updatePOStatus = async (body: { pO_Id?: number, pO_Status?: string, project_End_Date?: Date, notSendEmail?: boolean }) => {
        setLoading(true);
        let query = showTextArea ? `comment=${valuetextarea}&notSendEmail=${body.notSendEmail === true ? 1 : 0}` : `notSendEmail=${body.notSendEmail === true ? 1 : 0}`;
        delete body.notSendEmail;
        if (showTextArea && valuetextarea === "") {
            setErrortextarea(true);
        } else if (showTextArea && valuetextarea != "") {
            setErrortextarea(false);
            const response = await Fetch("vwPODetails", "POST", body, query, props.toast);
            if (response) {
                props.toast.current.show({ severity: 'success', content: "PO Status Updated Successfully." });
                onHide();
                props.setReload(!props.reload);
            }
        } else {
            const response = await Fetch("vwPODetails", "POST", body, null, props.toast);
            if (response) {
                props.toast.current.show({ severity: 'success', content: "PO Status Updated Successfully." });
                onHide();
                props.setReload(!props.reload);
            }
        }
        setLoading(false);
    }

    function onSubmit(data: { pO_Id?: number, pO_Status?: string, project_End_Date?: Date, notSendEmail?: boolean }) {
        data.pO_Id = props.po.pO_ID;
        updatePOStatus(data);
    }

    function onHide() {
        props.hideDialog();
        reset();
        setValuetextarea("");
        setShowTextArea(false);
        setErrortextarea(false);
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "pO_Status") {
                if (value.pO_Status === "Fizzled") {
                    setShowTextArea(true);
                }
                else {
                    setShowTextArea(false);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    const DateFormat = loginObj.date_Format;


    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Update PO Status" className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" value={[props.po]} showGridlines
            >
                <Column field="company_Name_Sales" header="Company Name" />
                <Column field="salesmanager" header="Sales Manager" body={(rowData) => { const value = rowData.salesmanager; if (!value) return ""; return value.split("-")[0]; }} />
                <Column field="user_Name" header="Recruiter"body={(rowData) => { const value = rowData.user_Name; if (!value) return ""; return value.split("-")[0]; }} />
                <Column field="consultant_Name" header="Consultant Name" />
                <Column field="project_Client_Name" header="End Client" />
                {/* <Column field="project_Start_Date1" header="Start Date" /> */}
                <Column field="project_Start_Date1" header="Start Date" body={(rowData: any) => safeFormatDate(rowData.project_Start_Date1, 'dd/MM/yyyy', DateFormat)} />
                <Column field="bRate" header="B Rate" />
                <Column field="sRate" header="S Rate" />
                <Column field="mRate" header="Margin " />
                <Column field="vendor_Company_Name" header="Client" />
                <Column field="sub_Vendor_Company" header="Vendor" />
                {/* <Column field="pO_Date1" header="PO Date" /> */}
                <Column field="pO_Date1" header="PO Date" body={(rowData: any) => safeFormatDate(rowData.pO_Date1, 'dd/MM/yyyy', DateFormat)}/>
                <Column field="pO_Status" header="Status" />
            </DataTable>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                <JVDate column={2} label="End Date" required control={control} name="project_End_Date" error={errors.project_End_Date?.message} />
                <JVDropdown required column={2} label="PO Status" control={control} name="pO_Status" error={errors.pO_Status?.message} options={POStatus} optionLabel="name" optionValue="name" placeholder="Select PO Status" />
                {(_roles.includes(1) || _roles.includes(47)) && <JVCheckbox column={6} label="Don't Send Email" control={control} name="notSendEmail" />}
                {showTextArea && <div className="ml-2">
                    <label >Fizzled Reason<span style={{ color: 'red' }}>*</span></label>
                    <InputTextarea className="ml-2" value={valuetextarea} onChange={(e) => { setValuetextarea(e.target.value); setErrortextarea(false) }} rows={5} cols={82} />
                    {errortextarea && <small className="p-error">Fizzled Reason is Required</small>}
                </div>}
                <div className="field col-12 md:col-12">
                    <Button loading={loading} label="UPDATE" type="submit"></Button>
                </div>
            </form>
        </Dialog>
    );
}